import { render, staticRenderFns } from "./DetailPair.vue?vue&type=template&id=5e0a7cbc&"
import script from "./DetailPair.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailPair.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailPair.vue?vue&type=style&index=0&id=5e0a7cbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports